import { RubroData } from './RubroData';

export class RubroListData {
  items: RubroData[];

  constructor(items: RubroData[]) {
    this.items = items;
  }
}
